import { fetcher } from "helpers/fetcher";

import {
  TGetStaffInterviewResultReq,
  TGetStaffInterviewResultRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffInterviewResult = async (
  payload: TGetStaffInterviewResultReq
) => {
  return await fetcher<TGetStaffInterviewResultRes, any>(
    ENDPOINT.MANAGEMENT.GET_STAFF_INTERVIEW_RESULT,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.MANAGEMENT.GET_STAFF_INTERVIEW_RESULT.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: {
        idStaff: payload.idStaff,
      },
    }
  );
};

export const queryGetStaffInterviewResult = async (
  payload: TGetStaffInterviewResultReq
) => {
  return (await getStaffInterviewResult(payload)).data;
};

queryGetStaffInterviewResult._key = (payload: TGetStaffInterviewResultReq) => [
  ENDPOINT.MANAGEMENT.GET_STAFF_INTERVIEW_RESULT.url,
  payload,
];
